import {useState} from 'react';
import {useDispatch} from 'react-redux';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Divider,
  Chip,
} from '@mui/material';
import Emitter from '@utils/eventEmitter'
import AddIcon from '@mui/icons-material/Add';
import BoardItemModal from './BoardItemModal'

import {
  adminDeleteBoard,
  adminUpdateBoard,
  adminCreateBoard,
} from '@store/admin/board';

const BoardModal = ({
  open,
  list,
  lists,
  onGetBoardList,
  closeModal
}) => {
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalInfo, setModalInfo] = useState(false);

  const onDeleteBoard = (boardId) => {
    Emitter.emit('SHOW_CONFIRM', {
      text: '삭제하시겠습니까?',
      successCb: async () => {
        const res = await dispatch(adminDeleteBoard({boardId}));
        if (res.payload) {
          onGetBoardList();
          Emitter.emit('SHOW_MESSAGE', {
            text: `삭제되었습니다.`
          })
        }
      }
    })
  };

  const onUpdateForm = async (targetBoard) => {
    const {boardId} = targetBoard;
    const apiMethod = boardId ? adminUpdateBoard : adminCreateBoard;
    const res = await dispatch(apiMethod({data: targetBoard}));
    if (res.payload) {
      onGetBoardList();
      Emitter.emit('SHOW_MESSAGE', {
        text: `${boardId ? '수정' : '추가'}되었습니다.`
      })
      closeItemModal();
    }
  };

  const closeItemModal = () => {
    setModalOpen(false);
  };

  const onShowBoardForm = (boardId) => {
    const info = boardId ? lists[boardId] : null;
    setModalInfo(info);
    setModalOpen(true);
  }


  return (
    <>
      <Dialog 
        open={open} 
        onClose={closeModal}
        fullWidth={true}
        maxWidth={'sm'}
      >
        <DialogTitle>게시판 설정</DialogTitle>
        <Divider />
        <DialogContent>
          <Stack spacing={2} direction="row">
            {
              list.map((boardId, index) => {
                return <BoardItem 
                  item={lists[boardId]} 
                  key={index} 
                  showBoardForm={onShowBoardForm}
                  deleteBoard={onDeleteBoard}
                />
              })
            }
            <Chip icon={<AddIcon />} color="info" label={'추가'} variant="outlined" onClick={() => onShowBoardForm()} />
          </Stack>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={closeModal}>닫기</Button>
        </DialogActions>
      </Dialog>

      {
        modalOpen && <BoardItemModal 
          open={modalOpen}
          data={modalInfo}
          updateModal={onUpdateForm}
          closeModal={closeItemModal}
        />
      }
    </>
  );
}

const BoardItem = ({
  item,
  showBoardForm,
  deleteBoard
}) => {
  const {name, boardId} = item;

  return <Chip 
    label={name} 
    onClick={() => showBoardForm(boardId)}
    onDelete={() => deleteBoard(boardId)} 
  />
}

export default BoardModal;